import { EVENT_SERVICE_URLS } from '../../Constants/Urls.constants';
import { REQUEST_ACTIONS } from '../../Constants/Actions.constants';
import { createQueriedURL, routeReplacer } from '../../Helpers/String.helper';
import { createRequestAction } from '../../Helpers/Action.helpers';
import { EventType, IEventUpdate } from '~/Models/DTO/Event.model';

export type EventListQuery = {
  providerId: string;
  eventGroupId?: string;
  eventSeriesIds?: string[];
  from?: string;
  to?: string;
  type?: string;
  waitingListEnabled?: boolean;
  livestream?: boolean;
  page?: number;
  size?: number;
};

export const requestEventList = (query: EventListQuery) =>
  createRequestAction({
    name: REQUEST_ACTIONS.GET_EVENT_LIST,
    url: createQueriedURL(EVENT_SERVICE_URLS.EVENT_LIST, query),
    method: 'GET',
  });

export const requestSingleEvent = (eventId: string) =>
  createRequestAction({
    name: REQUEST_ACTIONS.SINGLE_EVENT,
    url: routeReplacer(EVENT_SERVICE_URLS.EVENT_DETAIL, { id: eventId }),
    method: 'GET',
  });

export const deleteSingleEvent = (eventId: string) =>
  createRequestAction({
    name: REQUEST_ACTIONS.DELETE_SINGLE_EVENT,
    url: routeReplacer(EVENT_SERVICE_URLS.EVENT_DETAIL, { id: eventId }),
    method: 'DELETE',
    data: { eventId },
  });

export type EventgroupListQuery = {
  providerId: string;
};

export const requestEventGroupById = (groupId: string, eventType: EventType) =>
  createRequestAction({
    name: REQUEST_ACTIONS.GET_EVENTGROUP,
    url: routeReplacer(
      eventType === EventType.FREE_TRAINING
        ? EVENT_SERVICE_URLS.SINGLE_FREE_TRAININGS
        : EVENT_SERVICE_URLS.SINGLE_EVENTGROUP,
      { id: groupId },
    ),
    method: 'GET',
  });

export const requestUpdateEvent = (eventUpdate: IEventUpdate) =>
  createRequestAction({
    name: REQUEST_ACTIONS.UPDATE_EVENT,
    url: routeReplacer(EVENT_SERVICE_URLS.EVENT_DETAIL, { id: eventUpdate.id }),
    method: 'PUT',
    data: eventUpdate,
  });

export const requestEventCategories = () =>
  createRequestAction({
    name: REQUEST_ACTIONS.EVENTCATEGORIES,
    url: EVENT_SERVICE_URLS.EVENT_CATEGORY_TYPES,
    method: 'GET',
  });
export const requestSportCategories = () =>
  createRequestAction({
    name: REQUEST_ACTIONS.SPORTCATEGORIES,
    url: EVENT_SERVICE_URLS.SPORT_CATEGORY_TYPES,
    method: 'GET',
  });
